import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import LoaderComponent from "./LoaderComponent";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
} from "../../Util/authRedirect";

const PrivatePublicRoute = () => {
  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(userData);

  if (!rehydrated) return <LoaderComponent />;
  if (!authToken) return <Outlet />;
  return <Navigate to={getAuthenticatedHomeRoute(userData)} replace />;
};

export default PrivatePublicRoute;
